import { Link } from 'react-router-dom';

/** Keep the current workspace navigation visible while fresh submission data loads. */
export function SubmissionWorkspaceLoading({ submissionId, active, failed = false }: { submissionId: string; active: 'details' | 'compilation'; failed?: boolean }) {
  const base = `/submissions/${encodeURIComponent(submissionId)}`;
  return <div className="submission-workspace-tabs" aria-busy={!failed} data-testid="submission-workspace-loading">
    <div className="submission-workspace-context" style={{ background: 'var(--primary)', color: '#fff', minHeight: 64, boxSizing: 'border-box' }}>
      <span role="status" style={{ color: 'inherit' }}>{failed ? 'Submission unavailable' : 'Loading submission…'}</span>
    </div>
    <div className="submission-workspace-navigation">
      <nav aria-label="Submission workspace">
        <Link className="submission-workspace-tab" to={base} aria-current={active === 'details' ? 'page' : undefined}>Submission Details</Link>
        <Link className="submission-workspace-tab" to={`${base}/compiler`} aria-current={active === 'compilation' ? 'page' : undefined}>Submission Compilation</Link>
      </nav>
    </div>
  </div>;
}
